const parseUrlPath = (path: string) => {
  if (path.startsWith("http://") || path.startsWith("https://")) {
    return path;
  }

  return `${window.location.origin}${path}`;
};

export default parseUrlPath;
